module.exports = __webpack_public_path__ + "img/JQuery.112c7894.png";